import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=396cfdef&scoped=true"
import script from "./resourceList.vue?vue&type=script&lang=js"
export * from "./resourceList.vue?vue&type=script&lang=js"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=396cfdef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396cfdef",
  null
  
)

export default component.exports